<h1 class="title"> {{'MAIL-LIST-DETAILS.TITLE' | translate}} </h1>


<div class="add-btn">
    <button routerLink="/mail-list-details/new" mat-fab aria-label="">
        <mat-icon>add</mat-icon>
    </button>
</div>

<div style="max-width: 600px; margin: 0 auto;">
    <mat-card>
        <mat-card-content>
            <vzn-data-table #table [restService]="mailListService" [pageSize]="25" [columns]="columns" [query]="query"
                [mapper]="maillistMapper" (rowDblClick)="onDoubleClick($event)">
            </vzn-data-table>
        </mat-card-content>
    </mat-card>
</div>
<ng-template #deleteButtonTmpl let-row="row">
    <button mat-raised-button color="warn" (click)="deleteMailList(row)">{{ 'MAIN-APP.DELETE' | translate }}</button>
</ng-template>